import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import { Solutions, SolutionDetail } from "@/pages/Solutions";
import { Industries, IndustryDetail } from "@/pages/Industries";
import { Locations, LocationDetail } from "@/pages/Locations";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import { Blog, BlogPost } from "@/pages/Blog";
import NotFound from "@/pages/NotFound";

function Site({ children }) {
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Site><Home /></Site>} />
        <Route path="/hologram-stickers" element={<Site><Products variant="hologram" /></Site>} />
        <Route path="/security-labels" element={<Site><Products variant="security" /></Site>} />
        <Route path="/products" element={<Site><Products /></Site>} />
        <Route path="/products/:slug" element={<Site><ProductDetail /></Site>} />
        <Route path="/solutions" element={<Site><Solutions /></Site>} />
        <Route path="/solutions/:slug" element={<Site><SolutionDetail /></Site>} />
        <Route path="/industries" element={<Site><Industries /></Site>} />
        <Route path="/industries/:slug" element={<Site><IndustryDetail /></Site>} />
        <Route path="/locations" element={<Site><Locations /></Site>} />
        <Route path="/locations/:slug" element={<Site><LocationDetail /></Site>} />
        <Route path="/about-us" element={<Site><About /></Site>} />
        <Route path="/contact" element={<Site><Contact /></Site>} />
        <Route path="/blog" element={<Site><Blog /></Site>} />
        <Route path="/blog/:slug" element={<Site><BlogPost /></Site>} />
        <Route path="*" element={<Site><NotFound /></Site>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
